// extracted by mini-css-extract-plugin
export default {"card_Pregunta":"CuestionarioActividad_card_Pregunta__zk8Z1"};